import React, { useCallback, useEffect, useState } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import Logo from "../assets/Logo.png";
import StarIcon from "../assets/StartIcon.png";
import moment from "moment";
import { CurrentCaaqmsData, dataType } from "./type";
import { AQIDataItem, NoiseDataItem } from "../utils/types";
import { MarkerView } from "../components/MarkerView";
import { v4 as uuidv4 } from "uuid";
import { NoiseMarkerView } from "../components/NoiseMarkerView";

const Page3 = ({
  isLoaded,
  noiseData,
}: {
  isLoaded: boolean;
  noiseData: NoiseDataItem[];
}) => {
  const [map, setMap] = useState<any>(null);

  const onLoad = useCallback((map: any) => {
    setMap(map);
  }, []);

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  const containerStyle: React.CSSProperties = {
    width: "100%",
    height: "100%",
  };

  const center = {
    lat: 22.9868, // West Bengal coordinates
    lng: 87.855,
  };

  // const options = {
  //   mapTypeControl: true,
  //   mapTypeControlOptions: {
  //     position: window.google.maps.ControlPosition.BOTTOM_LEFT, // Move to bottom center
  //     style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
  //   },
  // };

  // const hours = new Date().getHours();
  // const [time, setTime] = useState<string>("");
  // const [isDayTime, setIsDayTime] = useState(hours > 6 && hours < 20);

  // useEffect(() => {
  //   // Update the time every second
  //   const intervalId = setInterval(() => {
  //     setIsDayTime(hours > 6 && hours < 20);
  //     setTime(moment().format("hh:mm A"));
  //   }, 1000);

  //   // Clean up the interval on component unmount
  //   return () => clearInterval(intervalId);
  // }, []);
  return (
    <div className="flex justify-center items-center w-screen h-screen  bg-[#181818]">
      <div className="w-full h-full bg-[#181818] flex flex-col items-center overflow-hidden">
        {/* Header bg-[#181818] */}

        <div className="w-full h-full">
          {isLoaded ? (
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              zoom={8}
              onLoad={onLoad}
              onUnmount={onUnmount}
              // options={options}
            >
              <div className="flex items-center justify-center absolute top-0 bg-white w-full text-center py-2 gap-1">
                <img src={Logo} className="w-12 h-12 " />
                <div className="">
                  <h1 className=" text-[#10A8FF] font-bold text-[1.5rem]">
                    WBPCB NOISE MONITORING SYSTEM
                  </h1>
                </div>
              </div>

              {noiseData?.map((data, index) => {
                return (
                  <NoiseMarkerView
                    key={uuidv4()}
                    data={data}
                    index={index}
                    // noAnimation={noAnimation}
                  />
                );
              })}
            </GoogleMap>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Page3;
